import PropTypes from 'prop-types';
import React from 'react';
import { Modal as BootstrapModal } from 'react-bootstrap';

const Modal = ({ onHide, headerText = '', children, ...props }) => {
  return (
    <BootstrapModal onHide={onHide} show {...props}>
      <BootstrapModal.Header closeButton className="border-0">
        <BootstrapModal.Title>{headerText}</BootstrapModal.Title>
      </BootstrapModal.Header>
      <BootstrapModal.Body className="text-center pt-0">
        {children}
      </BootstrapModal.Body>
    </BootstrapModal>
  );
};

Modal.propTypes = {
  onHide: PropTypes.func.isRequired,
  headerText: PropTypes.string,
  children: PropTypes.node.isRequired,
};
export default Modal;
